import { useState, useEffect } from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import ClearIcon from "@mui/icons-material/Clear";
// material
import { styled } from "@mui/material/styles";
import { Box, OutlinedInput, InputAdornment } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({ theme }) => ({
  maxHeight: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 6),
  flex: "1 1 auto",
  maxWidth: 260,
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(0, 1),
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: 170,
  },
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 190,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),

  "&.Mui-focused": { width: 230, boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    // borderColor: `${theme.palette.grey[500_32]} !important`,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    "&.Mui-focused": { width: "100%" },
  },
}));

// ----------------------------------------------------------------------

export default function ProductListToolbar() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const usedSearch = searchParams.get("search");
  const [search, setSearch] = useState(usedSearch || "");
  const onChange = (e) => {
    const val = e.target.value;
    setSearch(val);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (Boolean(search)) {
        searchParams.set("search", search);
        searchParams.delete("page");
        setSearchParams(searchParams);
      } else {
        searchParams.delete("search");
        searchParams.delete("page");
        setSearchParams(searchParams);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);
  useEffect(() => {
    setSearch("");
  }, [location.pathname]);
  return (
    <RootStyle>
      <SearchStyle
        size="small"
        value={search}
        onChange={onChange}
        placeholder="Search"
        startAdornment={
          <InputAdornment position="start">
            <SearchRoundedIcon sx={{ color: "text.disabled" }} />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            {search && (
              <ClearIcon
                sx={{ color: "text.disabled", cursor: "pointer" }}
                onClick={() => setSearch("")}
              />
            )}
          </InputAdornment>
        }
      />
    </RootStyle>
  );
}
